import { render, staticRenderFns } from "./RepairRequestList.vue?vue&type=template&id=1995ee6b&scoped=true"
import script from "./RepairRequestList.vue?vue&type=script&lang=js"
export * from "./RepairRequestList.vue?vue&type=script&lang=js"
import style0 from "./RepairRequestList.vue?vue&type=style&index=0&id=1995ee6b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1995ee6b",
  null
  
)

export default component.exports